module.exports = __webpack_public_path__ + "img/unicredit-bolditalic.d6cfd96a.svg";